<div class="col-xl">
    <!-- Dynamic suppliers section -->
    <form [formGroup]="form">
        <div formArrayName="suppliers" class="row">
            <div class="col-lg-12" *ngFor="let supplier of suppliers.controls; let i = index" [formGroupName]="i">
                <div class="card mb-4 rounded">
                    <div class="card-header d-flex justify-content-between align-items-center pb-3">
                        <h4 class="mb-0">Proveedor {{ indexToLetter(i) }}</h4>
                        <button *ngIf="i >= 2" type="button" class="btn btn-sm btn-outline-danger" (click)="removeSupplier(i)" [disabled]="suppliers.length < 3">Eliminar</button>
                    </div>
                    <div class="card-body">
                        <div class="mb-3 p-4 border rounded">
                            <div class="row">
                              <div class="col-lg-6">
                                <div class="row">
                                <div class="col-lg-12 col-xs-12 position-relative">
                                    <h6 class="mb-1"><b>{{!isExternal ? 'Nombre de refaccionaria' : 'Nombre del taller'}}</b></h6>
                                    <input type="text" placeholder="Ingresar" class="form-control" formControlName="workshop_name" (input)="onWorkshopInput(i, $event)">
                                    <!-- Autocomplete dropdown -->
                                    <div *ngIf="showOptions[i]" class="bg-white border rounded shadow-sm mt-1" style="position:absolute; z-index: 1000; width: 100%; max-height: 220px; overflow-y: auto;">
                                        <div class="px-3 py-2 hover-bg" *ngFor="let s of (supplierOptions[i] || [])" (click)="selectSupplier(i, s)" style="cursor:pointer;">
                                            <div class="fw-bold">{{ s.name || s.workshop_name }}</div>
                                            <small class="text-muted">{{ s.location || s.workshop_location || s.address }}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Ubicación {{!isExternal ? 'de refaccionaria' : 'del taller'}}</b></h6>
                                    <div class="input-group ubicacion">
                                      <span class="input-group-text">
                                        <img src="assets/img/icons/maintenance/elements.svg" alt="">
                                      </span>
                                      <input type="text" placeholder="Ingresar" class="form-control" formControlName="workshop_location" [appGooglePlaces]="suppliers.at(i).get('workshop_location')">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>{{!isExternal ? 'Costo de la refaccionaria' : 'Costo del taller'}}</b></h6>
                                    <input type="text"
                                           inputmode="decimal"
                                           placeholder="$0.00"
                                           class="form-control"
                                           formControlName="service_cost"
                                           [imask]="costMask"
                                           [unmask]="false">
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Tiempo estimado {{!isExternal ? 'de la refaccionaria' : 'del taller'}}</b></h6>
                                    <input type="date" placeholder="Ingresar" class="form-control" formControlName="estimated_time">
                                </div>
                                <div class="col-lg-12 col-xs-12 mt-3">
                                    <input type="file" #evidenceInput class="d-none" (change)="onFilesSelected($event, i)" accept="application/pdf">
                                    <!-- Show upload link when no file selected -->
                                    <a class="upload_file mt-3 justify-content-between align-items-center"
                                       *ngIf="!(suppliers.at(i).get('evidences')?.value?.length) && !(suppliers.at(i).get('attached_url')?.value)"
                                       (click)="$event.preventDefault(); evidenceInput.click();">
                                        <img src="assets/img/icons/maintenance/upload-04.svg" alt="" class="me-2" width="20">
                                        Subir cotización {{!isExternal ? 'de refaccionaria o tienda' : 'del taller'}}
                                    </a>
                                    <!-- Show existing attached_url when no new file is selected -->
                                    <div class="d-flex align-items-center mt-2"
                                         *ngIf="!(suppliers.at(i).get('evidences')?.value?.length) && (suppliers.at(i).get('attached_url')?.value)">
                                        <img src="assets/img/icons/maintenance/pdf-02.svg" alt="PDF" width="20" class="me-2">
                                        <a class="me-2" [href]="suppliers.at(i).get('attached_url')?.value" target="_blank" rel="noopener">
                                            Ver cotización existente
                                        </a>
                                        <a title="Quitar" class="ms-auto" (click)="removeAttachedUrl(i)">
                                            <img src="assets/img/icons/maintenance/elements_delete.svg" alt="" width="20">
                                        </a>
                                    </div>
                                    <!-- Show selected file chip when file exists -->
                                    <div class="d-flex align-items-center mt-2"
                                         *ngIf="suppliers.at(i).get('evidences')?.value?.length">
                                        <img src="assets/img/icons/maintenance/pdf-02.svg" alt="PDF" width="20" class="me-2">
                                        <a (click)="$event.preventDefault(); openEvidence(i)" class="me-2" >
                                            {{ suppliers.at(i).get('evidences')?.value[0]?.name || 'archivo.pdf' }}
                                        </a>
                                        <a title="Quitar" class="ms-auto" (click)="removeEvidence(i)">
                                            <img src="assets/img/icons/maintenance/elements_delete.svg" alt="" width="20">
                                        </a>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Banco</b></h6>
                                    <select class="form-select" formControlName="bank_id">
                                        <option [ngValue]="null">Seleccione</option>
                                        <option *ngFor="let b of dataBank" [ngValue]="b.id">{{ b.name }}</option>
                                    </select>
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Número de cuenta</b></h6>
                                    <input type="text"
                                           inputmode="numeric"
                                           placeholder="#### #### #### ####"
                                           class="form-control"
                                           formControlName="account_number"
                                           [imask]="accountMask"
                                           [unmask]="false">
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Nombre del titular</b></h6>
                                    <input type="text" placeholder="Ingresar" class="form-control" formControlName="account_holder">
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Tipo de pago</b></h6>
                                    <select class="form-select" formControlName="payment_type_id">
                                        <option [ngValue]="null">Seleccione</option>
                                        <option *ngFor="let p of dataPaymentType" [ngValue]="p.id">{{ p.name }}</option>
                                    </select>
                                </div>
                                </div>
                              </div>
                              <div class="col-lg-6 border-start">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h6 class="mb-0"><b>Materiales y refacciones</b></h6>
                                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="addRepairItem(i)">
                                        + Agregar otra refacción
                                    </button>
                                </div>
                                <div formArrayName="repair_items" class="repairs-list pe-1">
                                    <div class="repair-card border rounded p-3 mb-3" *ngFor="let item of repairItems(i).controls; let j = index" [formGroupName]="j">
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <h6 class="mb-0"><b>Refacción #{{ j + 1 }}</b></h6>
                                            <a title="Quitar" style="cursor:pointer;" (click)="removeRepairItem(i, j)">
                                                <img src="assets/img/icons/maintenance/elements_delete.svg" alt="" width="20">
                                            </a>
                                        </div>
                                        <input type="text" placeholder="Ingresar" class="form-control" formControlName="name"
                                               [class.is-invalid]="item.get('name')?.invalid && item.get('name')?.touched">
                                        <div class="row mt-2">
                                            <div class="col-4">
                                                <h6 class="mb-1"><b>Cantidad</b></h6>
                                                <div class="input-group qty-group">
                                                    <input type="number" min="0" step="1" class="form-control border-end-0" formControlName="quantity"
                                                           [class.is-invalid]="item.get('quantity')?.invalid && item.get('quantity')?.touched">
                                                    <span class="input-group-text qty-stepper">
                                                        <button type="button" tabindex="-1" (click)="stepQuantity(i, j, 1)"><span class="chev up"></span></button>
                                                        <button type="button" tabindex="-1" (click)="stepQuantity(i, j, -1)"><span class="chev down"></span></button>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-8">
                                                <h6 class="mb-1"><b>Subtotal</b></h6>
                                                <div class="input-group money-group">
                                                    <span class="input-group-text">$</span>
                                                    <input type="text"
                                                           inputmode="decimal"
                                                           placeholder="Ingresar"
                                                           class="form-control border-start-0 ps-0"
                                                           formControlName="subtotal"
                                                           [imask]="amountMask"
                                                           [unmask]="false"
                                                           [class.is-invalid]="item.get('subtotal')?.invalid && item.get('subtotal')?.touched">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="repairs-total-strip d-flex justify-content-between align-items-center rounded px-3 py-2 mb-3"
                                     *ngIf="repairItems(i).length > 0">
                                    <strong>Total refacciones:</strong>
                                    <span class="fw-bold fs-5">${{ formatAmount(getRepairTotal(i)) || '0' }} <small class="fs-6">MXN</small></span>
                                </div>
                                <hr>
                                <h6 class="mb-1"><b>Mano de obra</b></h6>
                                <h6 class="mb-1 mt-3"><b>Costo de mano de obra</b></h6>
                                <div class="input-group money-group">
                                    <input type="text"
                                           inputmode="decimal"
                                           placeholder="Ingresar"
                                           class="form-control border-end-0"
                                           formControlName="labor_cost"
                                           [imask]="amountMask"
                                           [unmask]="false">
                                    <span class="input-group-text">MXN</span>
                                </div>
                                <h6 class="mb-1 mt-3"><b>Descripción</b></h6>
                                <input type="text" placeholder="Ingresar" class="form-control" formControlName="labor_description">
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-lg-12 text-center">
            <button class="btn btn-outline-primary" (click)="submit(1)" [disabled]="!hasAtLeastOneValidSupplier()">Guardar registro</button>
            <span class="d-inline-block"
                  tabindex="0"
                  [attr.data-bs-toggle]="!canRequestAuthorization() ? 'tooltip' : null"
                  [attr.data-bs-title]="!canRequestAuthorization() ? 'Completa al menos 2 proveedores válidos y adjunta evidencia (archivo o existente) por cada uno.' : null">
                <button class="btn btn-primary ms-3"
                        (click)="submit(2)"
                        [disabled]="!canRequestAuthorization()">
                    Solicitar autorización
                </button>
            </span>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>